import { WebPlugin } from '@capacitor/core';
export class SunmiCardReaderWeb extends WebPlugin {
    async initSunmiSDK() {
        throw new Error('No web implementation please run the application on an android device [Sunmi Device]');
    }
    readCard() {
        throw new Error('No web implementation please run the application on an android device [Sunmi Device]');
    }
    async closeCardReader() {
        throw new Error('No web implementation please run the application on an android device [Sunmi Device]');
    }
    async getDeviceModel() {
        try {
            throw new Error('No web implementation please run the application on an android device [Sunmi Device]');
        }
        catch (e) {
            throw e;
        }
    }
}
//# sourceMappingURL=web.js.map